import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  topContainer: {
    marginTop: token.marginLG
  },

  card: {},

  formItem: {
    '.ant-form-item-label': {
      padding: '0 !important',

      label: {
        color: token.colorTextSecondary
      }
    }
  },

  tabs: {
    gap: 40,

    '.ant-tabs-nav-wrap': {
      width: 240
    },

    '.ant-tabs-nav-list': {
      borderLeft: `2px solid ${token.colorBorderSecondary}`,
      flex: '0 !important'
    },

    '.ant-tabs-ink-bar': {
      left: '-1% !important'
    },

    '.ant-tabs-tab': {
      paddingInline: `${token.padding}px 0px !important`
    },

    '.ant-tabs-tab+.ant-tabs-tab': {
      marginTop: `${token.marginXS}px !important`
    },

    '.ant-tabs-content-holder': {
      order: 1,
      border: 'none'
    },

    '.ant-tabs-tabpane': {
      padding: '0px !important'
    }
  },

  authMethodRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(140px, 1fr) auto auto',
    alignItems: 'center',
    gap: token.marginSM,
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      alignItems: 'flex-start'
    }
  },
  authMethodActionCol: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '& .ant-btn': {
      minWidth: 96,
      paddingInline: token.paddingSM
    }
  },
  organizationCardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: token.marginLG,
    '@media (max-width: 1280px)': {
      gridTemplateColumns: '1fr'
    }
  },
  orgCardTitleWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  orgCardSubtitle: {
    fontSize: token.fontSizeSM,
    color: token.colorTextSecondary
  },
  statusTag: {
    marginInlineEnd: 0,
    fontSize: token.fontSizeLG,
    lineHeight: '24px'
  },
  authMethodName: {
    fontSize: token.fontSizeLG,
    lineHeight: '24px'
  },
  managedByOrgText: {
    fontSize: token.fontSizeLG,
    lineHeight: '24px',
    whiteSpace: 'nowrap'
  }
}))
